const localStorageKey = {
  DEFAULT_LANG: "language",
  TOKEN: "token",
};

export default localStorageKey;
